module.exports = __webpack_public_path__ + "img/shape-5-gold@2x.46688a21.png";